import jwtDecode from 'jwt-decode';
import authApple from './authApple';
import authFb from './authFb';
import authGp from './authGp';
import authOneTap from './authOneTap';
import authVk from './authVk';
import authTinkoff from './authTinkoff';
import authYandex from './authYandex';
export default (function (type) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      stage = _ref.stage,
      sendGA = _ref.sendGA,
      oneTap = _ref.oneTap;

  var onSuccess = arguments.length > 2 ? arguments[2] : undefined;

  switch (type) {
    case 'vk':
      authVk(stage, function (data) {
        if (data) {
          var token = data.access_token,
              userId = data.user_id,
              fname = data.first_name,
              lname = data.last_name;
          onSuccess({
            token: token,
            userId: userId,
            name: "".concat(fname, " ").concat(lname)
          });
        }
      });
      break;

    case 'yandex':
      authYandex(stage, function (data) {
        if (data) {
          var token = data.token,
              userId = data.userId,
              name = data.name,
              email = data.email;
          onSuccess({
            token: token,
            userId: userId,
            name: name,
            email: email
          });
        }
      });
      break;

    case 'google':
      authGp(function (data) {
        if (data) {
          var token = data.token,
              email = data.email,
              name = data.name;
          onSuccess({
            token: token,
            userId: email,
            name: name
          });
        }
      });
      break;

    case 'oneTap':
      authOneTap(function (data) {
        if (data) {
          var jwt = data.credential;
          var user = jwtDecode(jwt);
          var email = user.email,
              name = user.name;
          onSuccess({
            token: jwt,
            userId: email,
            name: name
          });
        }
      }, sendGA, oneTap);
      break;

    case 'fb':
      authFb(function (data, user) {
        if (data) {
          var accessToken = data.accessToken,
              userID = data.userID;
          var name = user.name;
          onSuccess({
            token: accessToken,
            userId: userID,
            name: name
          });
        }
      });
      break;

    case 'apple':
      authApple(function (data, user) {
        var code = data.code;
        var result = {
          token: code
        };

        if (user) {
          if (user.email) {
            result.userId = user.email;
          }

          if (user.name) {
            var _user$name = user.name,
                firstName = _user$name.firstName,
                lastName = _user$name.lastName;
            var name = [firstName, lastName].filter(function (namePart) {
              return !!namePart;
            }).join(' ');

            if (name) {
              result.name = name;
            }
          }
        }

        onSuccess(result);
      });
      break;

    case 'tinkoff':
      authTinkoff(stage, function (data) {
        if (data) {
          var token = data.code,
              name = data.name;
          onSuccess({
            token: token,
            name: name
          });
        }
      });
      break;

    default:
      break;
  }
});